import { createContext } from 'react'
export const ListingScope = createContext<{ sale?: boolean; stock?: boolean }>({})
